import { render } from "./ReponseExpress.vue?vue&type=template&id=473103a1"
import script from "./ReponseExpress.vue?vue&type=script&lang=js"
export * from "./ReponseExpress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__